<script lang="ts" setup>
type Props = {
  href: string;
  target?: "_blank" | "_self";
};

withDefaults(defineProps<Props>(), {
  target: "_blank",
});

const { t } = useI18n();
</script>

<template>
  <div class="d-flex">
    <a class="btn btn-rounded btn-primary" :target="target" :href="href">
      <slot>
        {{ t("startPage.ctaBanner.more") }}
      </slot>
    </a>
  </div>
</template>
